import React from 'react';
import DctSvgIcon from '../../../components/atoms/Svg';

export const settings = () => ({
  dots: false,
  infinite: false,
  speed: 400,
  easing: "ease-out",
  swipe: true,
  rtl: false,
  slidesToShow: 3,
  slidesToScroll: true,
  initialSlide: 0,
  nextArrow: <button className='next-btn btns'><DctSvgIcon name="ArrowForwardIosSharp" /></button>,
  prevArrow: <button className='prev-btn btns'><DctSvgIcon name="ArrowBackIosSharp" /></button>,
  responsive: [
    {
      breakpoint: 1521,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        centerPadding: '24px',
        centerMode: false,
      },
    },
    {
      breakpoint: 1023,
      settings: {
        useCSS: false,
        slidesToShow: 1,
        centerPadding: '25px',
        useTransform: false,
        touchMove: false,
        useCSS: false,
        centerMode: true,
      },
    },
  ],
});
